<template>
    <div class="home-view">
        <Topbar />
        <br>
        <br>
        <div class="container-img mt-2 small pb-1" v-if="!this.retorno">
            <div class="col-md-6 m-auto mt-3">
                <div class="card small">
                    <div class="card-header text-white p-1" :style="{ backgroundColor: moduloAtual().color }">
                        Segunda Conferência
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="card-body p-1 text-left">
                        <InputDefaultApp
                            inputPlaceHolderSufixo="Bipe a nota fiscal"
                            titleScan="Escanear Nota Fiscal"
                            typeInputMode="numeric"
                            @displayScanFunction="buscarChaveNota"
                            :enterKey="(e) => buscarChaveNota(e.target.value)"
                            idInput="notaInput"
                            :errorMessage="this.error"
                        >
                        </InputDefaultApp>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-img mt-2 small pb-1" v-if="this.retorno">
            <div class="col-md-6 m-auto mt-3">
                <div class="card small">
                    <div class="card-header text-white p-1" :style="{ backgroundColor: moduloAtual().color }">
                        Segunda Conferência
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div class="card-body p-1 text-left">
                        <div class="btn-group w-100 text-center">
                            <span class="font-weight-bold ml-3">
                                {{ retorno.fantasia }}
                                -
                                {{ retorno.idclientes }}
                            </span>
                        </div>
                        
                        <div class="btn-group w-100 text-center">
                           <span class="ml-3 font-weight-bold">
                            Número Nota Fiscal
                           </span>
                           <div class="p-0 pl-1 d-inline font-weight-bold pr-1 text-danger ml-auto mr-2 rounded">
                                {{ retorno.numeronf }}
                            </div>
                        </div>
                        <div class="btn-group w-100 d-none text-center" v-if="this.endereco">
                           <span class="ml-3 font-weight-bold">
                            Endereço
                           </span>
                           <div class="p-0 pl-1 d-inline font-weight-bold pr-1 text-danger ml-auto mr-2 rounded">
                                {{ this.endereco.descricao }}
                            </div>
                        </div>
                        <div class="btn-group w-100 text-center" v-if="this.lote">
                           <span class="ml-3 font-weight-bold">
                            Lote / Validade
                           </span>
                           <div class="p-0 pl-1 d-inline font-weight-bold pr-1 text-danger ml-auto mr-2 rounded">
                            [{{ this.lote }}] - [{{ dateFormat(this.validade) }}]
                            </div>
                        </div>
                        <div class="btn-group w-100 text-center">
                           <span class="text-danger font-weight-bold ml-3">
                                {{ retorno.chavenfe }}
                           </span>
                        </div>
                        <div v-if="retorno.idreversas" class="btn-group w-100 text-center">
                            <span class="ml-3 font-weight-bold">
                            Reversa N°
                            </span>
                            <div class="p-0 pl-1 d-inline font-weight-bold pr-1 text-dark ml-auto mr-2 rounded">
                                <span class="rounded p-1 bg-warning">{{ retorno.idreversas }}</span>
                            </div>
                        </div>
                        <div class="mt-2" v-if="!this.endereco">
                            <InputDefaultApp
                                inputPlaceHolderSufixo="Digite o código do endereço"
                                titleScan="Escanear Endereço"
                                typeInputMode="text"
                                @displayScanFunction="buscarEndereco"
                                :enterKey="(e) => buscarEndereco(e.target.value, 1)"
                                idInput="enderecoInput"
                                :errorMessage="this.error"
                                :toUpperCase="true"
                            >
                            </InputDefaultApp>
                        </div>

                        <div class="mt-2" v-if="this.endereco">
                            <InputDefaultApp
                                inputPlaceHolderSufixo="Digite o código do produto"
                                titleScan="Escanear Produto"
                                typeInputMode="numeric"
                                @displayScanFunction="addConferencia"
                                :enterKey="(e) => addConferencia(e.target.value)"
                                idInput="codigoBarrasInput"
                                :errorMessage="this.error"
                            >
                            </InputDefaultApp>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="mt-1" v-if="this.retorno">
            <div class="col-md-6 m-auto mt-5 small">
                <div class="card small">
                    <div class="card-body p-1 d-flex">
                        <div class="w-75 text-left d-inline">
                            <span class="font-weight-bold text-danger">END.</span>
                            <span class="ml-1">
                                <span class="font-weight-bold" v-if="this.endereco">{{ this.endereco.descricao }}</span>
                            </span>
                        </div>
                        <div class="w-50 text-right d-inline">
                           <span class="font-weight-bold text-danger">QTD LIDA</span>
                           <span class="ml-1">
                                <span id="quantidadeLida">0</span> / <span id="quantidadeNota">0</span>
                           </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-1" v-if="this.retorno">
            <div class="col-md-6 m-auto mt-5 small">
                <div class="btn-group w-100">
                    <button class="btn btn-primary btn-sm btn-block" @click="Acoes">
                        Ações
                        <em class="fa fa-align-justify ml-2"></em>
                    </button>
                </div>
            </div>
        </div>

        <div class="mt-1" v-if="this.mostrarProdutos">
            <div class="col-md-6 m-auto mt-5 small">
                <div class="card small p-0 border-0">
                    <div class="card-body p-0 border-0">

                        <div class="border p-2 text-left rounded">
                            <span class="font-weight-bold text-danger">
                                {{ produtoBipado.produto.descricao.length > 42 ?  produtoBipado.produto.descricao.substring(0, 42) + "..." : produtoBipado.produto.descricao}}
                            </span>
                            <div class="border-top mt-1 mb-1"></div>
                            <span class="font-weight-bold">
                                Produto:
                            </span>
                            <span class="ml-2">{{ this.produtoBipado.produto.codbarras }}</span>
                            <br>
                            <span class="font-weight-bold">
                                SKU:
                            </span>
                            <span class="ml-2">{{ this.produtoBipado.produto.sku }}</span>
                            <br>
                            <span class="font-weight-bold">
                                Lote / Validade:
                            </span>
                            <span class="ml-2" v-if="produtoBipado.lote">[{{ this.produtoBipado.lote }}] - [{{ dateFormat(this.produtoBipado.validade) }}]</span>
                            <br>
                            <span class="font-weight-bold">
                                Quantidade:
                            </span>
                            <span class="ml-2">{{ this.produtoBipado.qtdeconf1 }} / {{ this.produtoBipado.qtde }}</span>
                            <br>
                            <span class="font-weight-bold">
                                Fator QTD:
                            </span>
                            <span class="ml-2">{{ this.produtoBipado.produto.fatorqtde }}</span>
                            <br>
                            <span class="font-weight-bold">
                                Shelf Life:
                            </span>
                            <span class="ml-2">{{ this.produtoBipado.produto.shelflife }}</span>
                            <br>
                            <span class="font-weight-bold">
                                End. Quarentena:
                            </span>
                            <span class="ml-2">[{{ this.endereco.quarentena }}]</span>
                            <br>
                            <span class="font-weight-bold">
                                End. Pulmão:
                            </span>
                            <span class="ml-2">[{{ this.endereco.pulmao }}]</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-5 text-center text-secondary" v-if="!this.retorno">
            <em class="fa fa-info-circle fa-3x mb-2"></em>
            <br>
            <span class="small">Bipe a chave da nota fiscal!</span>
        </div>

        <LogoutModal />

        <Modal
            id="modalLoteValidadeSelect"
            title="SELECIONE"
            :confirmFunction="() => selecionarLoteValidade()"
            :cancelFunction="() => closeModal('modalLoteValidadeSelect')"
        >
            <label for="loteSelecionar">LOTE/VALIDADE</label>
            <select id="loteSelecionar" class="form-control form-control-sm mb-2">
                <option :value="item.lote + ';' + item.validade + ';' + item.loteReal" v-for="(item) in this.lotesValidades" :key="item.lote+item.validade">
                    {{ item.lote }} - {{ dateFormat(item.validade) }}
                </option>
            </select>
            <span class="text-danger" v-if="this.errorSelecaoLoteValidade">LOTE/VALIDADE Inválidos!</span>
        </Modal>

        <Modal
            id="modalAddQuantidade"
            title="Inserir Qtde"
            :confirmFunction="() => AddQuantidade()"
            :cancelFunction="() => closeModal('modalAddQuantidade')"
        >
           <input
           inputmode="number"
           type="number"
           step="1"
           id="quantidadeAjustar"
           class="form-control form-control-sm"
           value="1"
           min="0"
           autocomplete="off"
           @keydown="(e) => { if (e.key === '.' || e.key === ',') { e.preventDefault(); }}">
        </Modal>

        <Modal
            id="modalAcoes"
            title="Ações"
            :buttonList="[]"
            :noFooter="true"
            :cancelFunction="() => closeModal('modalAcoes')"
        >
            <button v-if="this.mostrarProdutos" class="btn btn-success btn-sm btn-block" @click="modalAddQuantidade">
                Inserir Quantidade
                <em class="fa fa-edit ml-2"></em>
           </button>
           <button v-if="(this.lote !== null && this.validade !== null) || this.ativarModelLoteValidade === 'S'" class="btn btn-secondary btn-sm btn-block"
           @click="modalLoteValidadeSelectShow">
                Selecionar Lote/Validade
                <em class="fa fa-calendar ml-2"></em>
           </button>
           <button class="btn btn-info btn-sm btn-block" @click="inciarPesquisa">
                Modo Consulta
                <em class="fa fa-search  ml-2"></em>
           </button>
           <button class="btn btn-primary btn-sm btn-block" @click="NovaConferencia">
                Nova Conferência
                <em class="fa fa-plus-circle ml-2"></em>
           </button>
           
        </Modal>
        <Modal
            id="modalPesquisa"
            title="Pesquisar"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalPesquisa')"
        >
            <div class="text-left">
                <InputDefaultApp
                    inputPlaceHolderSufixo="Digite o código do produto"
                    titleScan="Escanear Produto"
                    typeInputMode="numeric"
                    @displayScanFunction="buscarProduto"
                    :enterKey="(e) => buscarProduto(e.target)"
                    idInput="buscarProduto"
                    :errorMessage="this.errorPesquisa"
                >
                </InputDefaultApp>
            </div>
        </Modal>

        <Modal
            id="modalResultadoPesquisa"
            title="Resultado"
            :confirmFunction="() => inciarPesquisa()"
            :cancelFunction="() => closeModal('modalResultadoPesquisa')"
            cancelText="Fechar"
            confirmText="Pesquisar"
        >
            <div class="small">
                <div class="border rounded p-2 w-100" style="height: 250px;">
                    <div style="overflow-y: auto; overflow-x: hidden; height: 100%; text-align: left;">
                        <span v-for="(item) in this.pesquisa" :key="item.idprodutos_has_enderecos">
                            <span><code class="font-weight-bold">ENDEREÇO:</code> {{ item.descricao }}</span><br>
                            <span><code class="font-weight-bold">PULMÃO:</code> {{ item.pulmao }}</span>
                            <span class="ml-2"><code class="font-weight-bold">QUARENTENA:</code> {{ item.quarentena }}</span>
                            <span class="ml-2"><code class="font-weight-bold">QTDE:</code> {{ item.qtde }}</span><br>
                            <span>
                                <code class="font-weight-bold">LOTE/VALIDADE:</code>
                                <span v-if="item.lote">
                                    {{ item.lote }} - {{ dateFormat(item.validade )}}
                                </span>
                            </span>
                            <br>
                            <span>
                                <code class="font-weight-bold">QTDE ENTRADA:</code>
                                    {{ item.qtdeentrada }}
                            </span>
                            <hr>
                        </span>
                    </div>
                </div>
            </div>
           
        </Modal>

    </div>
</template>

<script>
  // @ is an alias to /src
  import Topbar from '@/components/Topbar.vue'
  import LogoutModal from '@/components/LogoutModal.vue'
  import Modal from "../components/Modal.vue";
  import InputDefaultApp from '../components/InputDefaultApp.vue';
  import ViewMixin from './ViewMixin'
  import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
  import api, { getUserId, getUsername, getPerfil } from '../services/api'
  import $ from "jquery";
  import { dateFormat } from '../utils';
  import audioService from '@/services/audioService.js';

  export default {
    name: 'SegundaConferencia',
    mixins: [
      ViewMixin
    ],
    components: {
      Topbar,
      LogoutModal,
      Modal,
      InputDefaultApp
    },
  
    data: () => {
        return {
            scanAberto: false,
            chaveNotaReferencia: null,
            quantidadeAdicionar: 1,
            endereco: null,
            retorno: null,
            error: null,
            pulmao: "N",
            lote: null,
            validade: null,
            ativarModelLoteValidade : "S",
            confirmacaoConferencia: "S",
            lotesValidades: [],
            codigoBarrasReferencia: null,
            produtoBipado: null,
            mostrarProdutos: false,
            serialInformad: "N",
            errorSelecaoLoteValidade: false,
            pesquisa: [],
            errorPesquisa: null,
            permitiuTrocarOlote: 'N',
        }
    },

    async mounted() {

        try {
            await this.validarToken();
        } catch (e) {
            if (e instanceof TokenInvalidoException) {
                this.handleTokenInvalidoException();
            } else if (e instanceof ServerErrorException) {
                alert(e.message);
            } else {
                alert(DEFAULT_ERROR_MESSAGE);
            }      
        }


        setTimeout(() => {
            document.getElementById('notaInput').focus();
            document.getElementById('notaInput').select();
        }, 1000);
    },

    methods: {
        getUsername,
        getPerfil,
        dateFormat,

        playSound() {
            audioService.ops();
        },

        closeModal(modalId) {
            $('#'+modalId).modal('hide');
            this.onModalClosed();
        },

        onModalClosed() {
            let codigoBarrasInput = document.getElementById("codigoBarrasInput");
            let enderecoInput = document.getElementById("enderecoInput");

            if (codigoBarrasInput !== null && codigoBarrasInput !== undefined) {
                codigoBarrasInput.focus();
                codigoBarrasInput.select();
            }
            if (enderecoInput !== null && enderecoInput !== undefined) {
                enderecoInput.focus();
                enderecoInput.select();
            }
        },

        async validarToken() {
            this.carregando = true;
    
            await api.get("/validar-token");
    
            this.carregando = false;
        },

        transformToUpperCase(event) {
            event.target.value = event.target.value.toUpperCase();
            this.$emit('input', event.target.value);
        },

        buscarChaveNota(value) {
            if (value.trim() !== "" && value.trim().length == 44) {
                this.chaveNotaReferencia = value;
                this.consultar();
            } else {
                this.error = "A chave da nota precisa ter 44 caracteres!";
                let notaInput = document.getElementById('notaInput');
                notaInput.select();
                notaInput.focus();
                this.playSound();
            }
        },

        async consultar() {

            this.carregando = true;
            try {

                let body = {
                    chave: this.chaveNotaReferencia,
                    idUsuario: getUserId()
                };

                let response = await api.post(`/inbound/segundaconferencia/nota`, body);
                this.retorno = response.data;

                this.focusEndereco();

                this.error = null;
            } catch(e) {
                this.error = e.message;
                this.retorno = null;

                let notaInput = document.getElementById('notaInput');
                notaInput.select();
                notaInput.focus();
                this.playSound();
            }

            this.carregando = false;
        },

        focusEndereco() {
            setTimeout(() => {
                let enderecoInput = document.getElementById('enderecoInput');

                enderecoInput.select();
                enderecoInput.focus();
            }, 1000);
        },

        focusCodigoBarras() {
            setTimeout(() => {
                let codigoBarrasInput = document.getElementById('codigoBarrasInput');

                codigoBarrasInput.select();
                codigoBarrasInput.focus();
            }, 1000);
        },

        async buscarEndereco(endereco) {

            this.carregando = true;
            try {

                let body = {
                    descricao: endereco
                };

                let response = await api.post(`/inbound/segundaconferencia/endereco`, body);
                this.endereco = response.data;

                this.error = null;
                this.focusCodigoBarras();
            } catch(e) {
                this.error = e.message;
                this.endereco = null;

                let enderecoInput = document.getElementById('enderecoInput');
                enderecoInput.select();
                enderecoInput.focus();
                this.playSound();
            }

            this.carregando = false;
        },

        async addConferencia(codigoBarras) {
            
            if (codigoBarras !== this.codigoBarrasReferencia && this.codigoBarrasReferencia !== null) {
                this.lote = null;
                this.validade = null;
                this.ativarModelLoteValidade = "S";
                this.codigoBarrasReferencia = codigoBarras;

                if (codigoBarras.split(".").length >= 2) {
                    this.buscarEndereco(codigoBarras);
                    return;
                }
            }

            this.codigoBarrasReferencia = codigoBarras;
            
            this.carregando = true;
            try {

                let body = {
                    "codigoBarras" : codigoBarras,
                    "endereco": this.endereco.descricao,
                    "chave": this.chaveNotaReferencia,
                    "pulmao": this.pulmao,
                    "lote": this.lote,
                    "validade": this.validade,
                    "ativarModelLoteValidade" : this.ativarModelLoteValidade,
                    "confirmacaoConferencia": this.confirmacaoConferencia,
                    "quantidade": this.quantidadeAdicionar
                };

                let response = await api.post(`/inbound/segundaconferencia/add`, body);

                if (JSON.stringify(response.data).includes("produtoNotaFiscal")) {
                    this.mostrarProdutos = true;
                    this.produtoBipado = response.data.produtoNotaFiscal;

                    let quantidadeLidaSpan = document.getElementById('quantidadeLida');
                    let quantidadeNotaSpan = document.getElementById('quantidadeNota');

                    quantidadeLidaSpan.innerText = this.produtoBipado.qtdeconf2;
                    quantidadeNotaSpan.innerText = this.produtoBipado.qtdeconf1;

                } else if (JSON.stringify(response.data).includes("enderecos")) {

                    let lotes = [];
                    for (const item of response.data.enderecos) {
                        let arr = item.split(" - ");

                        lotes.push({
                            lote: arr[0],
                            validade: arr[1],
                            loteReal: arr[2]
                        });
                    }

                    this.lotesValidades = lotes;
                    $("#loteSelecionar").css("border", "1px solid #CCC");
                    $("#modalLoteValidadeSelect").modal('show');
                }

                let codigoBarrasInput = document.getElementById('codigoBarrasInput');
                codigoBarrasInput.select();
                codigoBarrasInput.focus();
                this.error = null;
            } catch(e) {
                this.error = e.message;

                if (this.error.includes("Produto já existe com outro lote e/ou data de validade no mesmo endereço!")) {
                    this.ativarModelLoteValidade = "S";
                    this.permitiuTrocarOlote = "S";
                    this.lote = null;
                    this.validade = null;
                }

                if (e.message.includes("Quantidade da Segunda Conferência ultrapassará a quantidade da Primeira Conferência, Clique em 'Confirmar' para continuar."))
                {
                    this.playSound();
                } else {
                    let codigoBarrasInput = document.getElementById('codigoBarrasInput');
                    codigoBarrasInput.select();
                    codigoBarrasInput.focus();
                    this.playSound();
                }
            }

            this.carregando = false;
        },

        selecionarLoteValidade() {
            let arr = $("#loteSelecionar").val().split(";");

            this.lote = arr[0];
            let dataValidade = arr[1];
            let dia = dataValidade.substring(0, 2);
            let mes = dataValidade.substring(3, 5);
            let ano = dataValidade.substring(6, 10);

            this.validade = ano + "-" + mes + "-" + dia;

            if (this.produtoBipado) {
                this.produtoBipado.lote = this.lote;
                this.produtoBipado.validade = this.validade;
            }

            let loteReal = arr[2];

            if (loteReal !== "V") {
                $("#modalLoteValidadeSelect").modal('show');
                $("#loteSelecionar").css("border", "1px solid red");
                this.errorSelecaoLoteValidade = true;
                this.playSound();
            } else {
                if (this.confirmacaoConferencia === "S") {
                    this.ativarModelLoteValidade = "N";
                    this.errorSelecaoLoteValidade = false;
                    $("#loteSelecionar").css("border", "1px solid #CCC");
                    this.addConferencia(this.codigoBarrasReferencia);
                }

                if (this.permitiuTrocarOlote === "S") {
                    this.ativarModelLoteValidade = "N";
                    this.errorSelecaoLoteValidade = false;
                    $("#loteSelecionar").css("border", "1px solid #CCC");
                    this.permitiuTrocarOlote = "N";
                    this.confirmacaoConferencia = "S";
                }
                
                this.closeModal('modalLoteValidadeSelect');
            }
        },

        focusProduto() {
            setTimeout(() => { 
                let produtoInput = document.getElementById('produtoInput');

                if (produtoInput !== null) {
                    produtoInput.select();
                    produtoInput.focus();
                }
            }, 1000);
        },

        Acoes() {
            $("#modalAcoes").modal("show");
        },

        NovaConferencia() {
            this.retorno = null;
            $("#modalAcoes").modal("hide");
            
            setTimeout(() => {
                this.chaveNotaReferencia= null;
                this.retorno= null;
                this.error= null;
                this.lote = null;
                this.validade = null;
                this.serialInformado= "N";
                this.codigoBarrasReferencia= null;
                this.produtoBipado = null;
                this.mostrarProdutos = false;
                this.confirmacaoConferencia = "S";
                this.endereco=null;
                this.ativarModelLoteValidade = 'S';
            }, 250);

            setTimeout(() => {
                $("#notaInput").focus();
                $("#notaInput").select();
            }, 500);
        },

        modalLoteValidadeSelectShow() {
            this.confirmacaoConferencia = "N";

            $("#modalAcoes").modal("hide");
            $('#modalLoteValidadeSelect').modal("show");
        },

        modalAddQuantidade() {
            $("#modalAcoes").modal("hide");
            $('#modalAddQuantidade').modal("show");

            setTimeout(() => {
                $("#quantidadeAjustar").val(1);
                $("#quantidadeAjustar").focus();
                $("#quantidadeAjustar").select();
            }, 500);
        },

        AddQuantidade() {
            this.carregando = true;

            this.quantidadeAdicionar = $("#quantidadeAjustar").val();
            this. addConferencia(this.codigoBarrasReferencia);
            this.confirmacaoConferencia = "S";
            
            this.quantidadeAdicionar = 1;

            this.closeModal('modalAddQuantidade');

            this.carregando = false;
        },

        inciarPesquisa() {
            $("#modalAcoes").modal("hide");
            $('#modalResultadoPesquisa').modal("hide");
            $('#modalPesquisa').modal("show");

            setTimeout(() => {
                $("#buscarProduto").val("");
                
            }, 250);

            setTimeout(() => {
                $("#buscarProduto").select();
                $("#buscarProduto").focus();
            }, 1000);
        },

        async buscarProduto(element) {
            this.errorPesquisa = null;

            let body = {
                codigoBarras: element.value
            };

            try {
                let response = await api.post(`/inbound/segundaconferencia/consulta/produto`, body);
                this.pesquisa = response.data;
                $("#modalPesquisa").modal("hide");
                $('#modalResultadoPesquisa').modal("show");
            } catch (e) {
                $("#buscarProduto").focus();
                $("#buscarProduto").select();
                
                this.errorPesquisa = e.message;
                this.playSound();
                return;
            }         
        }
    }
}
</script>

<style scoped lang="scss">    
  
    .home-view {
      height: 100%;
    }

    .icon-input {
        position: absolute;
        top: 20%;
        right: 30px;
        font-size: 18px;
    }

    .icon-cam {
        position: absolute;
        top: 20%;
        right: 5px;
        font-size: 18px;
    }
  
    .input-container input {
        width: 80%;
    }


    .icon-input-textarea {
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 18px;
    }

    input[type=checkbox] {
        accent-color: #6C757D;
        position: relative;
        top: 3px
    }

    .codigo-text {
        min-width: 60px;
    }
</style>